import EventiMenu from "../eventimenu";

const routes = [
    { name: "EventiMenuList", path: "/configurazioneeventimenu", component: EventiMenu.EventiMenuList, meta: { title: "Eventi Menu" } },
    { name: "EventiMenuEdit", path: "/configurazioneeventimenu/edit/:id", component: EventiMenu.EventiMenuEdit, meta: { title: "" } },
];
export default routes;
